<div class="SearchContainer Flexbox Flexbox--column">
  <div class="TopContainer Flexbox Flexbox--column Gap--smaller">
    <div class="InputContainer Flexbox Align--center Gap--smaller">
      <mat-form-field appearance="outline" class="SearchInput">
        <mat-label>Filter Designs</mat-label>
        <input matInput #search [(ngModel)]="searchText" (ngModelChange)="searchTextChange()" (blur)="onInputBlur()">
      </mat-form-field>
      <mat-form-field appearance="outline" class="CategoriesSelect">
        <mat-label>Categories</mat-label>
        <mat-select [value]="selectedDesignCategories()" (valueChange)="categoryFilterChange($event)" [compareWith]="compareCategories" multiple>
          <mat-option *ngFor="let category of categories()" [value]="category">{{ category.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button hidden mat-icon-button (click)="closeClick.emit()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <!-- <mat-slide-toggle [checked]="shouldShowUnavailable()" (change)="showUnavailableChange($event.checked)">Show Unavailable</mat-slide-toggle> -->
  </div>
</div>